<template>
  <div class="content-links">
    <BaseStoryblokComponent
      v-for="item in blok.items"
      :id="id"
      :key="item._uid"
      :blok="item"
      class="content-links__item"
      :title="title"
    />
  </div>
</template>

<script setup lang="ts">
import BaseStoryblokComponent from '@/components/Base/BaseStoryblokComponent/BaseStoryblokComponent.vue'
import { type SbBlokData } from '@/components/Base/BaseStoryblokComponent/types'

defineProps<{
  blok: {
    items: SbBlokData[]
  }
  title: string
  id: string
}>()
</script>

<style lang="scss">
.content-links {
  display: flex;
  gap: $sb-size-unit-base;
  width: max-content;
  margin: 0 auto;
}
</style>
